import { Box, Divider, Stack, styled } from "@mui/material";
import { Bounce } from "react-toastify";

export const toastifyConfig = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: "dark",
  transition: Bounce,
};

export const PracticeName = styled(Stack)`
  padding: 0.5rem 2rem;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;
  color: #0085ff;
  background-color: #0085ff1a;

  font-size: 16px;
  font-weight: 600;
`;

export const PracticeLabel = styled(Box)`
  color: #71839b;
  font-weight: 400;
`;

export const Error = styled(Box)`
  margin: 0 14px;
  font-size: 12px;
  font-family: sans-serif;
  color: #d32f2f;
`;

export const checkBoxSx = {
  userSelect: "none",
  textAlign: "left",
  "& .MuiFormControlLabel-label": {
    fontSize: "0.75rem",
    color: "#000000",
  },
  "&:hover": {
    backgroundColor: "#f0f0f0",
  },
  padding: "0",
  margin: "0",
};

export const types = {
  Notification: "Notification",
  Referral: "Referral",
  Question: "Question",
};

export const ButtonInfo = ({ recipientName, provider, sender }) => (
  <Stack alignItems={"stretch"} gap={1}>
    <PracticeName>
      <PracticeLabel>Recipient:</PracticeLabel> {recipientName}
    </PracticeName>
    <Divider />
    <div className="text-left text-sm">
      Provider: <span className="text-black">{provider}</span>
    </div>
    {sender && (
      <div className="text-left text-sm">
        Person completing form: <span className="text-black">{sender}</span>
      </div>
    )}
    <Divider />
  </Stack>
);

/** @type {import("types").PatientFormDataWithCode} */
export const defaultValues = {
  id: "",
  status: "",
  originatorName: "",
  originatorEmail: "",
  originatorPhone: "",
  recipientName: "",
  buttonType: "",
  patientName: "",
  patientPhone: "",
  patientDob: "",
  type: types.Notification,
  oneTimeCode: "",
  question: "",
  reason: "",
};
